import { useState } from "react";
import { ListProduct } from "../components/product/ListProduct";
import { CreateProduct } from "../components/product/CreateProduct";
import UpdateProduct from "../components/product/UpdateProduct";

export const Product = () => {
  const [mode, setMode] = useState<"create" | "edit" | "list">("list");
  const [selectedId, setSelectedId] = useState<string>("");
  if (mode === "create") {
    return <CreateProduct onBack={() => setMode("list")} />;
  }
  if (mode === "edit") {
    return (
      <UpdateProduct onBack={() => setMode("list")} selectedId={selectedId} />
    );
  }
  return (
    <ListProduct
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
